import React from 'react';
import { RefundPolicyContent } from '../../../shared/legal/RefundPolicyContent';
import LandingPolicyShell from '../components/LandingPolicyShell';

export default function RefundPolicy() {
    return (
        <LandingPolicyShell title="Refund Policy">
            <RefundPolicyContent variant="page" />
        </LandingPolicyShell>
    );
}
